import { Font, Line, Svg } from "@react-pdf/renderer";

// Charte commune des documents PDF de Believemy (livret d'accueil,
// attestation de fin de formation) : polices, couleurs et trame des cartes
// sociales.
//
// Polices : les instances statiques og-* de public/static/fonts (react-pdf,
// comme Satori, ne lit pas une police variable). Dans le navigateur on les
// sert depuis l'origine courante ; hors navigateur (script de rendu), depuis
// le dossier public du dépôt.
export const asset = (chemin) =>
    typeof window === "undefined"
        ? `${process.cwd()}/public${chemin}`
        : `${window.location.origin}${chemin}`;

Font.register({
    family: "SourceSans",
    fonts: [
        { src: asset("/static/fonts/og-SourceSans3-Regular.ttf"), fontWeight: 400 },
        { src: asset("/static/fonts/og-SourceSans3-SemiBold.ttf"), fontWeight: 600 },
    ],
});
Font.register({
    family: "SourceCode",
    src: asset("/static/fonts/og-SourceCodePro-Medium.ttf"),
});
Font.register({
    family: "Geist",
    src: asset("/static/fonts/og-Geist-Black.ttf"),
});
// Pas de césure automatique : un mot coupé en fin de ligne fait brouillon.
Font.registerHyphenationCallback((mot) => [mot]);

export const ENCRE = "#0B1020";
export const TEXTE = "#2A3140";
export const DOUX = "#6B7385";
export const ACCENT = "#E8511D";
export const BLEU = "#8FB4E8";
export const BLEU_FONCE = "#3D5A8A";
export const SURFACE = "#F4F6FA";
export const FILET = "#E3E7EF";

// react-pdf (4.9) n'affiche pas un texte rendu à la volée (numéro de page,
// prop render) qui porte un interligne, même hérité de la page : le texte et
// tout le bloc fixe qui le contient disparaissent. Un interligne nul le
// ramène à celui de la police.
export const SANS_INTERLIGNE = { lineHeight: 0 };

// Un point de moins que la page : à la taille exacte, react-pdf pousse le
// dessin sur une deuxième page.
export const A4 = { largeur: 594, hauteur: 840 };

// La trame et les équerres des cartes sociales, sur toute la page (couverture
// du livret) ou sur un bandeau (attestation).
export function Trame({
    largeur = A4.largeur,
    hauteur = A4.hauteur,
    marge = 28,
    bras = 22,
}) {
    const pas = 28;
    const verticales = [];
    for (let x = pas; x < largeur; x += pas) verticales.push(x);
    const horizontales = [];
    for (let y = pas; y < hauteur; y += pas) horizontales.push(y);
    const equerres = [
        [marge, marge, 1, 1],
        [largeur - marge, marge, -1, 1],
        [marge, hauteur - marge, 1, -1],
        [largeur - marge, hauteur - marge, -1, -1],
    ];
    return (
        <Svg
            width={largeur}
            height={hauteur}
            style={{ position: "absolute", top: 0, left: 0 }}
        >
            {verticales.map((x) => (
                <Line
                    key={`v${x}`}
                    x1={x}
                    y1={0}
                    x2={x}
                    y2={hauteur}
                    stroke="#18223A"
                    strokeWidth={0.6}
                />
            ))}
            {horizontales.map((y) => (
                <Line
                    key={`h${y}`}
                    x1={0}
                    y1={y}
                    x2={largeur}
                    y2={y}
                    stroke="#18223A"
                    strokeWidth={0.6}
                />
            ))}
            {equerres.flatMap(([x, y, sx, sy], i) => [
                <Line
                    key={`eh${i}`}
                    x1={x}
                    y1={y}
                    x2={x + sx * bras}
                    y2={y}
                    stroke="#4A5B80"
                    strokeWidth={1.2}
                />,
                <Line
                    key={`ev${i}`}
                    x1={x}
                    y1={y}
                    x2={x}
                    y2={y + sy * bras}
                    stroke="#4A5B80"
                    strokeWidth={1.2}
                />,
            ])}
        </Svg>
    );
}
